import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { TICKET_STATUS } from '../../../../../config/constants';
import {printCreditNotes} from '../../../../../utils/printers/CreditNote';

class PrintCreditNoteButton extends Component {
  handlePrintCreditNote = () => {
    const { ticket } = this.props;

    const ticketJs = ticket.toJS();

    if (ticketJs.ticketStatus === TICKET_STATUS.REFUNDED.value) {
      ticketJs.salePrice = ticketJs.creditNoteTotalAmount;
      ticketJs.salePriceString = ticketJs.creditNoteTotalAmountString;
    }

    printCreditNotes(ticketJs);
  };

  render() {
    const { ticket } = this.props;
    const ticketJs = ticket.toJS();
    return (
      <Button
        color="light"
        className="border"
        onClick={this.handlePrintCreditNote}
      >
        <i className="fa fa-print" />
        {ticketJs.ticketStatus === TICKET_STATUS.REFUNDED.value
          ? ' Imprimir Devolución'
          : ' Imprimir Postergación'}
      </Button>
    );
  }
}

PrintCreditNoteButton.propTypes = {
  ticket: PropTypes.instanceOf(Map).isRequired,
};

export default PrintCreditNoteButton;
